import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-79a86a24")
const _hoisted_1 = {
  key: 0,
  class: "fullscreen"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "background" }, null, -1)
const _hoisted_3 = ["src"]
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CloseIcon = _resolveComponent("CloseIcon")!

  return (_ctx.$store.state.isFullScreen != null)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("iframe", {
          src: 
        'https://www.youtube.com/embed/' +
        _ctx.$store.state.isFullScreen +
        '?playlist='+ _ctx.$store.state.isFullScreen +'&autoplay=1&rel=0&controls=1&loop=1'
      ,
          title: "YouTube video player",
          frameborder: "0",
          allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
          allowfullscreen: ""
        }, null, 8, _hoisted_3),
        _createElementVNode("button", {
          class: "close-icon",
          onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.StopFullScreen()))
        }, [
          _createVNode(_component_CloseIcon)
        ])
      ]))
    : _createCommentVNode("", true)
}